export default {
  VIEW: 'view',
  EDIT: 'edit'
};